import {
    FETCH_PREFERENCES,
    SET_DEFAULT_PREFERENCES,
    UPDATE_PREFERENCES
} from './actionTypes';

const fetchPreferences = () => ({
    type: FETCH_PREFERENCES,
    errors: null
});

const setDefaultPreferences = () => ({
    type: SET_DEFAULT_PREFERENCES,
    errors: null
});


const updatePreferences = ({paymentAlerts, reports}) => ({
    type: UPDATE_PREFERENCES,
    payload: {
        paymentAlerts,
        reports,
    },
    errors: null
});

export {
    fetchPreferences, setDefaultPreferences, updatePreferences
}